
'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  mediator = require('mediatorjs'),
  config = require('../../js/config'),
  $global = require('../../js/globalElements'),
  $window = $global.$window,
  imgIndex = 0,
  incrementForRetina = 0; // We are focussing performance for non-retina config.isHiDef ? 1 : 0;

import {isBrowserLoaded} from '../../utilities/browser';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

Backbone.$ = $;

var ResponsiveBackgroundImageView = Backbone.View.extend({

  initialize: function() {
    _.bindAll(this, 'selectImage');

    this.images = this.$el.data('images');
    this.sizes = this.$el.data('sizes');

    if (this.$el.length && this.sizes) {
      var shouldDelay = this.$el.is('.js-responsive-bg-image--delayed') && !isBrowserLoaded();
      if (!shouldDelay) {
        this.selectImage(this.sizes);
      } else {
        $window.on('load', () => {
          this.selectImage(this.sizes);
        });
      }
      mediator.on(config.events.ui.resize, this.selectImage);
    }
  },

  applyImage: function(imgPath) {
    this.$el.css({'background-image': 'url(' + imgPath + ')'});
  },

  /**
   * Iterate through each passed size until we reach the window size then return that image path
   */
  selectImage: function(imgSizes) {
    let sizes = imgSizes || this.sizes;
    let windowWidth = $window.width();
    let chosenIndex = 0;
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i] <= windowWidth) {
        imgIndex = i;
      }
    }
    chosenIndex = (imgIndex < sizes.length - 1) ? imgIndex + incrementForRetina : imgIndex;
    this.applyImage(this.images[chosenIndex]);
  }

}, {
  create: function($parent) {
    parallelArrayEach($parent.find('.js-responsive-bg-image'), (el) => new ResponsiveBackgroundImageView({ el: el }));
  }
});

module.exports = ResponsiveBackgroundImageView;



// WEBPACK FOOTER //
// ./assets/components/ResponsiveBackgroundImage/ResponsiveBackgroundImageView.js